import { analytics } from '../services/analytics'
import { Achievement, AchievementLevel } from '@/types'
import { globalState } from '@codeleap/store'
import { TypeGuards } from '@codeleap/types'
import { createGlobalTimeout } from '@/utils/utility'

type State = {
  achievement: Achievement | null
  levels: AchievementLevel[] | null
  modalVisible: boolean
  toastVisible: boolean
}

export const state = globalState<State>({
  achievement: null,
  levels: null,
  modalVisible: false,
  toastVisible: false,
})

export const toggleModal = (achievement?: Achievement) => {
  if (TypeGuards.isNil(achievement)) {
    state.set({ modalVisible: false })
  } else {
    state.set({ achievement, modalVisible: true })
  }
}

export const closeToast = () => {
  state.set({ toastVisible: false })
  setTimeout(() => state.set({ levels: null }), 250)
}

const toastTimeout = createGlobalTimeout('timeout')

export const verifyProgress = (achievementProgress: AchievementLevel[], to = true) => {
  const achievementLevel = achievementProgress?.[0]

  if (!TypeGuards.isNil(achievementLevel)) {
    state.set({ toastVisible: to, levels: achievementProgress })

    analytics?.track?.('badge_awarded', {
      badge_level: `${achievementLevel?.achievement?.name} ${achievementLevel?.name}`,
    })

    toastTimeout.set(closeToast, 6000)

    return true
  }

  return false
}

export const mockAchievement = [
  {
    achievement: {
      id: 11,
      name: 'Climate Feed Liker',
      description: 'You have liked {user_progress} items in feed',
      levels: null,
      next_level_descriptor: null,
      progression_metric: 'feed_items_liked',
    },
    achievement_progress: 5,
    bg_color: '#329CA9',
    bg_color_light: '#D7F8FC',
    congratulatory_message: 'Congratulations!',
    description: 'You have liked 5 items in feed',
    id: 52,
    image: 'https://cdn.hurd.codeleap.co.uk/media/public/achievement_levels/Property_1Liker_levelsilver.png',
    is_current: true,
    is_none: false,
    name: 'Silver',
    next_level_descriptor: 'Like 5 more for Gold',
    progress_descriptor: '5/10',
    progression_required: 5,
    tag_image: 'star',
    verbose_progress: '5 of 5 items',
  },
]
